import { CountUp } from 'countup.js';

function ready(fn) {
	if (document.readyState !== 'loading'){
		fn();
	} else {
		document.addEventListener('DOMContentLoaded', fn);
	}
}

ready(function () {
	document.querySelectorAll("[data-counting-number]").forEach((el) => {

		const text = el.textContent
		const number = el.textContent.match(/[0-9]+([.,][0-9]+)*/g)

		if (number && number.length === 1) {

			const [prefix, suffix] = text.split(number[0]);

			let useGrouping = false
			let decimal = null
			let separator = '.'
			let decimalPlaces = 0
			let endVal = parseInt(number[0])
			let startVal = 0

			if (number[0].length > 2 && number[0].slice(-2, -1) === ',') {
				decimal = ','
				separator = '.'
				decimalPlaces = 1
				useGrouping = number[0].indexOf('.') !== -1
				endVal = parseFloat(number[0].replaceAll('.', '').replace(',', '.'))
				startVal = parseFloat(endVal.toString().replaceAll(/[0-9]/g, '0').replace('0', '1'))
			} else if (number[0].length > 3 && number[0].slice(-3, -2) === ',') {
				decimal = ','
				separator = '.'
				decimalPlaces = 2
				useGrouping = number[0].indexOf('.') !== -1
				endVal = parseFloat(number[0].replaceAll('.', '').replace(',', '.'))
				startVal = parseFloat(endVal.toString().replaceAll(/[0-9]/g, '0').replace('0', '1'))
			} else if (number[0].length > 2 && number[0].slice(-2, -1) === '.') {
				decimal = '.'
				separator = ','
				decimalPlaces = 1
				useGrouping = number[0].indexOf(',') !== -1
				endVal = parseFloat(number[0].replaceAll(',', ''))
				startVal = parseFloat(endVal.toString().replaceAll(/[0-9]/g, '0').replace('0', '1'))
			} else if (number[0].length > 3 && number[0].slice(-3, -2) === '.') {
				decimal = '.'
				separator = ','
				decimalPlaces = 2
				useGrouping = number[0].indexOf(',') !== -1
				endVal = parseFloat(number[0].replaceAll(',', ''))
				startVal = parseFloat(endVal.toString().replaceAll(/[0-9]/g, '0').replace('0', '1'))
			} else if (number[0].indexOf('.') !== -1) {
				decimal = ','
				separator = '.'
				decimalPlaces = 0
				useGrouping = true
				endVal = parseInt(number[0].replaceAll('.', ''))
				startVal = parseInt(endVal.toString().replaceAll(/[0-9]/g, '0').replace('0', '1'))
			} else if (number[0].indexOf(',') !== -1) {
				decimal = '.'
				separator = ','
				decimalPlaces = 0
				useGrouping = true
				endVal = parseInt(number[0].replaceAll(',', ''))
				startVal = parseInt(endVal.toString().replaceAll(/[0-9]/g, '0').replace('0', '1'))
			} else {
				decimal = null
				separator = null
				decimalPlaces = 0
				useGrouping = false
				endVal = parseInt(number[0])
				startVal = parseInt(endVal.toString().replaceAll(/[0-9]/g, '0').replace('0', '1'))
			}

			//startVal = 0

			new CountUp(el, endVal, {
				startVal: 0,
				decimalPlaces: decimalPlaces,
				duration: 2,
				useGrouping: useGrouping, // or false
				separator: separator,
				decimal: decimal,
				prefix: prefix,
				suffix: suffix,
				enableScrollSpy: true,
				scrollSpyOnce: true,
			});
		}
	})
});
